import PropTypes from 'prop-types';
import React from 'react';
import {
  Col,
  Grid,
  Row,
} from 'react-bootstrap';
import Panel from '../Panel.jsx';
import createLoginLink from './createLoginLink.js';
import browserIsIE from '../utilities/browserIsIE.js';

const EmailMessage = ({
  username,
}) => (
  <Panel>
    <Grid fluid style={{marginRight: '-20px', width: browserIsIE() ? '100%' : null}}>
      <Row
        style={{
          fontSize: '14px',
          fontWeight: 400,
        }}
      >
        <Col xs={12}>
          <p>
            An email containing a link to reset your password has been sent to the address on file for <strong>{username}</strong>.
          </p>
          <p>
            The reset link will be valid for 1 hour.
          </p>
          <p>
            If you do not receive the email, please check your spam folder and/or contact Support for further assistance.
          </p>
        </Col>
      </Row>
    </Grid>
    <a
      href={createLoginLink()}
      style={{
        paddingTop: '40px',
      }}
    >
        Go back to login
    </a>
  </Panel>
);

EmailMessage.propTypes = {
  returnUrl: PropTypes.string,
  username: PropTypes.string,
};

export default EmailMessage;
